export function getFormType() {
  const t = window.location.hash||'';
  if (t.includes('innovate')){
    return 'innovate'
  }
  if (t.includes('scientist')){
    return 'scientist'
  }

  return 'innovate';
}

export function getUrlParam(key) {
  return new URLSearchParams(window.location.hash).get(key)
}
